module.exports = __webpack_public_path__ + "assets/Monash_Big_M_42x96.png?19f4b451d5e27d077f1de4b1f0550299";